export default __webpack_public_path__ + "static/benifitImage2-9956f92fbfc80fbaa472efb03806841d.webp";